__webpack_require__.p = "https://tastermpoint-mfe-dashboard-stage.maersk.io/mfe/dashboard/";